import { Instance } from 'mobx-state-tree';
import { ShopifyOrdersResultDtoModelBase } from './ShopifyOrdersResultDtoModel.base';

/* The TypeScript type of an instance of ShopifyOrdersResultDtoModel */
export interface ShopifyOrdersResultDtoModelType extends Instance<typeof ShopifyOrdersResultDtoModel.Type> {}

/* A graphql query fragment builders for ShopifyOrdersResultDtoModel */
export { selectFromShopifyOrdersResultDto, shopifyOrdersResultDtoModelPrimitives, ShopifyOrdersResultDtoModelSelector } from './ShopifyOrdersResultDtoModel.base';

/**
 * ShopifyOrdersResultDtoModel
 */
export const ShopifyOrdersResultDtoModel = ShopifyOrdersResultDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
